/**
 * Created by mohameds on 4/7/19.
 */
import React from 'react';
import NumberFormat from 'react-number-format';
import {MonitorConst} from '../Constants';

//used for formatting the value
const calcNumber = (dataType, number, index) =>{
  let totalFormat;
  if (dataType === MonitorConst.CurrencyType.CURRENCY) {
    totalFormat = <NumberFormat key={index} 
                      value={number} displayType={'text'} thousandSeparator={true} decimalScale={0}
                      prefix={'$'} className="font-32" 
                  />;
  } else if (dataType === MonitorConst.CurrencyType.PERCENTAGE) {
    totalFormat = <NumberFormat key={index}
                      value={number} displayType={'text'} thousandSeparator={true} decimalScale={2}
                      suffix={' %'} className="font-36" 
                  />;
  } else {
    totalFormat = <NumberFormat key={index} className="font-36" 
                      value={number} displayType={'text'} thousandSeparator={true} decimalScale={0}
                  />;
  }
  return totalFormat ? totalFormat : 0
};

const CardPage = ({text, goal=0, actual=0, dataType, index , showGoal}) =>{
  return (
    <div className="col-md-3 col-sm-4 mb-3">
      <div className="card text-center position-relative bg-info mb-0 h-100">
        <h2 className="m-0 text-white py-2 px-3">{text}</h2>
        <div className="row bg-white m-0 bottom-row border border-info">
          {showGoal ?
            <React.Fragment>
          <div className="col-md-6 py-2">
            <h3 className="mb-1">Goal</h3>
            <h2 className="text-maroon mb-1">
              {calcNumber(dataType, goal, index)}
            </h2>
          </div>
          <div className="col-md-6 py-2 border-left">
            <h3 className="mb-1">Actual</h3>
            <h2 className="text-success mb-1" >
              {calcNumber(dataType, actual, index)}
            </h2>
          </div>
            </React.Fragment>
            :
            <div className="col-md-12 py-2 border-left">
              <h3 className="mb-1">Actual</h3>
              <h2 className="text-success mb-1" >
                {calcNumber(dataType, actual, index)}
              </h2>
            </div>
          }
        </div>
        <div className="row m-0 bottom-row-none border border-info">
          {showGoal ?
            <React.Fragment>
              <div className="col-md-6 py-2">
                <h3 className="mb-1">Goal</h3>
                <h2 className="text-maroon mb-1">
                  {calcNumber(dataType, goal, index)}
                </h2>
              </div>
              <div className="col-md-6 py-2 border-left">
                <h3 className="mb-1">Actual</h3>
                <h2 className="text-success mb-1" >
                  {calcNumber(dataType, actual, index)}
                </h2>
              </div>
            </React.Fragment>
            :
            <div className="col-md-12 py-2 border-left">
              <h3 className="mb-1">Actual</h3>
              <h2 className="text-success mb-1" >
                {calcNumber(dataType, actual, index)}
              </h2>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
export default CardPage;



// WEBPACK FOOTER //
// ./src/components/agencyMonitor/common/Card.js